import { useLocation } from 'react-router-dom'

const specialPaths = ['login', 'logout', 'organization', 'dashboard']

export default (): string | undefined => {
    const location = useLocation()
    const paths = location.pathname
        .split('/')
        .filter((v) => v)
    const path = paths?.[0]
    if (specialPaths.includes(path)) {
        return undefined
    }
    return path
}
